import normal from './hover.png'
import notice from './notice.png'

export default {
  normal,
  notice,
}
